<template>
    <paper class="payment-duration-mip" v-loading="loading">
        <div class="btn">
            <el-button
                type="primary"
                :loading="loading"
                :disabled="!mipUrl"
                @click="submitMip"
            >
                MIP审批提交</el-button
            >
        </div>

        <el-divider></el-divider>

        <div class="content-wrapper">
            <div class="title">司机收款时长配置</div>
            <el-form :model="formData" :rules="rules" ref="formRef">
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item
                            label="供应商编码："
                            label-width="110px"
                            prop="carrierCode"
                        >
                            <el-input
                                v-model="formData.carrierCode"
                                disabled
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="供应商名称：" label-width="110px">
                            <el-input
                                v-model="formData.carrierName"
                                disabled
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item
                            label="配置维度："
                            label-width="110px"
                            prop="configType"
                        >
                            <otpSelect
                                :optionNum="'CONFIG_TYPE'"
                                :mValue="formData.configType"
                                placeholder="请选择"
                                :prop="'configType'"
                                :disabled="true"
                            >
                            </otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            label="司机收款时长："
                            label-width="110px"
                            prop="paymentType"
                        >
                            <otpSelect
                                :optionNum="'PAYMENT_TYPE'"
                                :mValue="formData.paymentType"
                                placeholder="请选择"
                                :prop="'paymentType'"
                                :disabled="true"
                            >
                            </otpSelect>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item>
                            <el-input
                                v-model="formData.uniteDay"
                                v-if="+formData.paymentType === 10"
                                placeholder="请输入收款时长天数"
                                disabled
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item
                        label="配置维度明细："
                        label-width="110px"
                        prop="detailConfig"
                    >
                        <el-button
                            type="primary"
                            disabled
                            >明细选择</el-button
                        >
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="table-wrapper">
                <el-table :data="tableData" border height="200" width="100%">
                    <el-table-column
                        prop="detailConfigurationName"
                        label="配置维度明细项"
                        min-width="250"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="detailConfigurationDay"
                        label="司机收款时长（天）"
                        min-width="200"
                    >
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <iframe ref="frameRef" class="ifr" :src="mipUrl" v-if="mipUrl && !loading" />
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import otpSelect from '@/components/lots/otpSelect';
import { initDetail, createProcess } from '../../../../api/driverPaymentDurationConfig.js';
import { mapState } from 'vuex';
import { iflowPageURL } from '../../../../utils/iflowConf';
export default {
    name: 'PaymentDurationMip',
    components: { paper, otpSelect },
    data () {
        return {
            formData: {
                carrierCode: '',
                carrierName: '',
                configType: '',
                paymentType: '',
                uniteDay: '',
                configId: '',
                detailConfig: ''
            },
            rules: {
                carrierCode: [{ required: true, message: '请选择供应商', trigger: ['change', 'blur'] }],
                carrierName: [{ required: true, message: '请选择供应商', trigger: ['change', 'blur'] }],
                configType: [{ required: true, message: '请选择配置维度', trigger: ['change', 'blur'] }],
                paymentType: [{ required: true, message: '请选择司机收款时长设置', trigger: ['change', 'blur'] }],
                uniteDay: [{ required: true, message: '请选择收款时长天数', trigger: ['change', 'blur'] }],
                detailConfig: [{ required: true }]
            },
            tableData: [],
            requestId: '',
            iflowCode: '',
            loading: false,
            tableLoading: false,
            mipUrl: '',
            iflowStatus: '',
            createUserCode: '',
            currentPath: '/otp/transport-center/payment-duration-mip'
        };
    },
    computed: {
        ...mapState({
            user: state => state.user,
            currentTenant: state => state.currentTenant
        })
    },
    async mounted () {
        if (this.$route.query.requestId) {
            this.requestId = this.$route.query.requestId;
            await this.init();
            window.addEventListener('message', this.messageFunc, false);
        }
    },
    async activated () {
        if (this.$route.query.requestId) {
            this.requestId = this.$route.query.requestId;
            await this.init();
            window.addEventListener('message', this.messageFunc, false);
        }
    },
    destroyed () {
        window.removeEventListener('message', this.messageFunc, false);
    },
    methods: {
        init () {
            this.loading = true;
            initDetail({ requestId: this.requestId }).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = res.data.list || [];
                    this.mipUrl = res.data.iflowId ? iflowPageURL(this.user, res.data.iflowId) : '';
                    Object.keys(this.formData).forEach(key => {
                        this.formData[key] = res.data[key] || '';
                    });
                }
            }).catch(() => {
            }).finally(() => {
                this.loading = false;
            });
        },
        submitMip () {
            this.$refs.frameRef.contentWindow.postMessage('mbpm_getApprovalData', this.mipUrl);
        },
        messageFunc (event) {
            // 只有在当前页面触发，才执行相应的监听事件
            if (this.$route.path !== this.currentPath) return;
            if (event.data && event.data.data && event.data.success) {
                const params = event.data.data;
                this.loading = true;
                createProcess(params)
                    .then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功');
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.init();
                        }, 3000);
                    });
            }
        }
    }
};
</script>

<style lang="less">
.payment-duration-mip {
    .el-divider--horizontal {
        margin: 12px 0;
    }
    .content-wrapper {
        .title {
            margin-bottom: 6px;
            font-size: 14px;
            font-weight: 600;
        }
        .tooltip {
            font-size: 12px;
            color: red;
        }
        .el-form-item__label {
            line-height: 26px;
        }
        .el-form-item__content {
            line-height: 26px;
        }
        .el-form-item__content .el-input-group {
            vertical-align: middle;
        }
        .el-select {
            width: 100%;
        }
        .table-wrapper {
            margin-left: 110px;
            margin-right: 110px;
            .el-table--border {
                border-right: 1px solid #ebeef5;
                border-bottom: 1px solid #ebeef5;
            }
            .el-table td {
                padding: 2px 0;
            }
        }
    }
    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
        margin-top: 30px;
    }
}
</style>
